export default __webpack_public_path__ + "static/media/ChestboxOpen.6e2114a6.png";